import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios from "axios";
import moment from "jalali-moment";
import { storage } from "../../utils";
import utils from "../../components/toastify/toastify";

const limit = (value) => value ? value : "نامحدود";

const GetDiscountCodes = () => {
  const [codes, setCodes] = useState([]);
  const [redemptions, setRedemptions] = useState(null);
  const [loadingRedemptions, setLoadingRedemptions] = useState(false);
  const load = async () => {
    try {
      const token = await storage.load("token");
      const { data } = await Axios.get("/get_discount_codes", { headers: { "x-auth": token } });
      setCodes(data.data || []);
    } catch (_) { utils.showAlert("دریافت کدهای تخفیف انجام نشد", "error"); }
  };
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("این کد تخفیف حذف شود؟")) return;
    try {
      const token = await storage.load("token");
      await Axios.post("/delete_discount_code", { id }, { headers: { "x-auth": token } });
      load();
    } catch (_) { utils.showAlert("حذف کد تخفیف انجام نشد", "error"); }
  };
  const showRedemptions = async (item) => {
    setLoadingRedemptions(true);
    try {
      const token = await storage.load("token");
      const { data } = await Axios.get(`/get_discount_code/${item._id}/redemptions`, { headers: { "x-auth": token } });
      setRedemptions({ code: item.code, users: data.data || [] });
    } catch (_) { utils.showAlert("دریافت استفاده‌کنندگان کد تخفیف انجام نشد", "error"); }
    finally { setLoadingRedemptions(false); }
  };
  return (
    <div className="content-body" dir="rtl">
      <div className="mb-2">
        <Link className="btn btn-success" to="/dashboard/addDiscountCode">افزودن کد تخفیف</Link>
      </div>
      {redemptions && (
        <div className="card mb-2">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">استفاده‌کنندگان کد {redemptions.code}</h4>
            <button className="btn btn-sm btn-light" onClick={() => setRedemptions(null)}>بستن</button>
          </div>
          <div className="card-body table-responsive">
            <table className="table mb-0">
              <thead><tr><th>نام کاربر</th><th>شماره موبایل</th><th>تعداد استفاده</th><th>آخرین استفاده</th></tr></thead>
              <tbody>
                {redemptions.users.length ? redemptions.users.map((entry) => (
                  <tr key={String(entry.user_id)}>
                    <td>{entry.name || "—"}</td>
                    <td dir="ltr">{entry.phone_number || "—"}</td>
                    <td>{entry.usage_count}</td>
                    <td>{entry.last_used_at ? moment(entry.last_used_at).locale("fa").format("YYYY/MM/DD HH:mm") : "—"}</td>
                  </tr>
                )) : <tr><td colSpan="4" className="text-center">هنوز استفادهٔ تکمیل‌شده‌ای ثبت نشده است.</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div className="card">
        <div className="card-body table-responsive">
          <table className="table mb-0">
            <thead><tr><th>کد</th><th>تخفیف</th><th>استفاده</th><th>سقف هر کاربر</th><th>انقضا</th><th>وضعیت</th><th>عملیات</th></tr></thead>
            <tbody>
              {codes.length ? codes.map((item) => (
                <tr key={item._id}>
                  <td>{item.code}</td>
                  <td>{item.discount_percent}٪</td>
                  <td>{item.usage_count || 0} / {limit(item.max_total_uses)}</td>
                  <td>{limit(item.max_uses_per_user)}</td>
                  <td>{item.expiration_date ? moment(item.expiration_date).locale("fa").format("YYYY/MM/DD") : "بدون انقضا"}</td>
                  <td>{item.status ? "فعال" : "غیرفعال"}</td>
                  <td>
                    <button className="btn btn-info btn-sm ml-1" disabled={loadingRedemptions} onClick={() => showRedemptions(item)}>کاربران</button>
                    <Link className="btn btn-primary btn-sm ml-1" to={`/dashboard/editDiscountCode/${item._id}`}>ویرایش</Link>
                    <button className="btn btn-danger btn-sm" onClick={() => remove(item._id)}>حذف</button>
                  </td>
                </tr>
              )) : <tr><td colSpan="7" className="text-center">کد تخفیفی ثبت نشده است.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { GetDiscountCodes };
